/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Content_DescriptionInputs */

const en_share_content_description = /** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a listing or recent post to share with the community.`)
};

const es_share_content_description = /** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un anuncio o publicación reciente para compartir con la comunidad.`)
};

const fr_share_content_description = /** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez une annonce ou un article récent à partager avec la communauté.`)
};

const de_share_content_description = /** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle ein Inserat oder einen aktuellen Beitrag aus, um ihn mit der Community zu teilen.`)
};

const id_share_content_description = /** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih listing atau posting terbaru untuk dibagikan dengan komunitas.`)
};

/** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */
const ja_share_content_description = en_share_content_description;

/** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */
const zh_share_content_description = en_share_content_description;

/** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */
const ar_share_content_description = en_share_content_description;

/** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */
const it_share_content_description = en_share_content_description;

/** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */
const ru_share_content_description = en_share_content_description;

/** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */
const pt_share_content_description = en_share_content_description;

/** @type {(inputs: Share_Content_DescriptionInputs) => LocalizedString} */
const ko_share_content_description = en_share_content_description;

/**
* | output |
* | --- |
* | "Select a listing or recent post to share with the community." |
*
* @param {Share_Content_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const share_content_description = /** @type {((inputs?: Share_Content_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Content_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_content_description(inputs)
	if (locale === "es") return es_share_content_description(inputs)
	if (locale === "fr") return fr_share_content_description(inputs)
	if (locale === "de") return de_share_content_description(inputs)
	if (locale === "ja") return ja_share_content_description(inputs)
	if (locale === "zh") return zh_share_content_description(inputs)
	if (locale === "ar") return ar_share_content_description(inputs)
	if (locale === "id") return id_share_content_description(inputs)
	if (locale === "it") return it_share_content_description(inputs)
	if (locale === "ru") return ru_share_content_description(inputs)
	if (locale === "pt") return pt_share_content_description(inputs)
	return ko_share_content_description(inputs)
});